import { cn } from '../lib/utils';

export function BrandLogo({
  variant = 'mark',
  className
}: {
  variant?: 'mark' | 'wordmark';
  className?: string;
}) {
  return (
    <img
      src={variant === 'wordmark' ? '/brand/storyly-wordmark.png' : '/brand/storyly-mark.png'}
      alt="Storyly"
      className={cn('block h-auto w-auto', className)}
    />
  );
}
